import { AppAccent } from '../types/app-accent.type';

export const APP_MODULE_ACCENTS_ENABLED: Record<AppAccent, boolean> = {
  default: true,
  resultados: true,
  solicitacao: true,
  unidade: true,
  gestao: true,
  manutencao: true,
  tutoriais: true,
  perfil: true,
};
